import { LogIn } from 'lucide-react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { Button } from '../components/ui/button.tsx';
import { Loading } from '../components/ui/feedback.tsx';

/**
 * There is no login form: the brand's OAuth server owns it. This page starts
 * the flow, and shows the one failure the server sends back (`?error=oauth`)
 * instead of looping into it.
 */
export function LoginPage() {
  const [params] = useSearchParams();
  const failed = params.get('error') === 'oauth';

  useEffect(() => {
    if (!failed) window.location.replace('/auth/login');
  }, [failed]);

  if (!failed) return <Loading label="Taking you to sign in…" />;

  return (
    <div className="flex min-h-full items-center justify-center p-5">
      <div className="page-in w-full max-w-sm rounded-[1.75rem] bg-surface p-8 text-center shadow-[0_24px_60px_-28px_rgba(15,27,45,0.35),0_0_0_1px_var(--line)]">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-soft text-brand">
          <LogIn className="h-6 w-6" aria-hidden />
        </span>
        <h1 className="mt-5 font-display text-2xl font-semibold text-ink">Login did not complete</h1>
        <p className="mt-2 text-[0.95rem] text-muted">The sign-in server turned the request down, or the session ran out. Signing in again usually fixes it.</p>
        <Button asChild size="lg" className="mt-7 w-full">
          <a href="/auth/login">Sign in again</a>
        </Button>
      </div>
    </div>
  );
}
